const GpsIcon = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.00054 8.83714C2.88426 8.83714 1.16333 7.11621 1.16333 4.99993C1.16333 2.88365 2.88426 1.16272 5.00054 1.16272C7.11682 1.16272 8.83776 2.88365 8.83776 4.99993C8.83776 7.11621 7.11682 8.83714 5.00054 8.83714ZM5.00054 1.86039C3.27031 1.86039 1.86101 3.2697 1.86101 4.99993C1.86101 6.73017 3.27031 8.13947 5.00054 8.13947C6.73078 8.13947 8.14008 6.73017 8.14008 4.99993C8.14008 3.2697 6.73078 1.86039 5.00054 1.86039Z"
      fill="currentColor"
    />
    <path
      d="M4.9998 6.74423C4.03701 6.74423 3.25562 5.96284 3.25562 5.00005C3.25562 4.03726 4.03701 3.25586 4.9998 3.25586C5.96259 3.25586 6.74399 4.03726 6.74399 5.00005C6.74399 5.96284 5.96259 6.74423 4.9998 6.74423ZM4.9998 3.95353C4.42306 3.95353 3.95329 4.4233 3.95329 5.00005C3.95329 5.57679 4.42306 6.04656 4.9998 6.04656C5.57655 6.04656 6.04632 5.57679 6.04632 5.00005C6.04632 4.4233 5.57655 3.95353 4.9998 3.95353Z"
      fill="currentColor"
    />
    <path
      d="M5.00094 1.62791C4.81024 1.62791 4.6521 1.46977 4.6521 1.27907V0.348837C4.6521 0.15814 4.81024 0 5.00094 0C5.19163 0 5.34977 0.15814 5.34977 0.348837V1.27907C5.34977 1.46977 5.19163 1.62791 5.00094 1.62791Z"
      fill="currentColor"
    />
    <path
      d="M1.27907 5.3488H0.348837C0.15814 5.3488 0 5.19066 0 4.99996C0 4.80926 0.15814 4.65112 0.348837 4.65112H1.27907C1.46977 4.65112 1.62791 4.80926 1.62791 4.99996C1.62791 5.19066 1.46977 5.3488 1.27907 5.3488Z"
      fill="currentColor"
    />
    <path
      d="M5.00094 9.99998C4.81024 9.99998 4.6521 9.84184 4.6521 9.65114V8.72091C4.6521 8.53021 4.81024 8.37207 5.00094 8.37207C5.19163 8.37207 5.34977 8.53021 5.34977 8.72091V9.65114C5.34977 9.84184 5.19163 9.99998 5.00094 9.99998Z"
      fill="currentColor"
    />
    <path
      d="M9.65187 5.3488H8.72164C8.53094 5.3488 8.3728 5.19066 8.3728 4.99996C8.3728 4.80926 8.53094 4.65112 8.72164 4.65112H9.65187C9.84257 4.65112 10.0007 4.80926 10.0007 4.99996C10.0007 5.19066 9.84257 5.3488 9.65187 5.3488Z"
      fill="currentColor"
    />
  </svg>
);
export default GpsIcon;
